import "./Icons.scss";

function Arrow() {
  return (
    <svg viewBox="0 0 193.41 300.11" className="icon">
      <path
        d="M54.16,150.41c23.5,20.14,46.4,39.76,69.29,59.39,20.37,17.46,40.84,34.8,61.05,52.44,11.36,9.91,10.36,26.33-1.68,34.28-8.4,5.55-18.28,4.63-26.68-2.55q-30.39-26-60.75-52Q52.12,204.87,8.82,167.8c-6.9-5.9-10.58-13.18-8-22.1A25.25,25.25,0,0,1,8,134.09Q82.88,69.43,158.22,5.24a21,21,0,0,1,30,2.29c7.78,9.14,6.75,22.15-2.76,30.33q-47.92,41.25-96,82.31Z"
        className="primary"
      />
    </svg>
  );
}

export default Arrow;
